import React, { useMemo } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { ThemeContextProvider, useThemeContext } from '../contexts/ThemeContext';
import { createAppTheme } from '../theme';
import CookieConsentBanner from '../components/CookieConsentBanner';

const ThemeBridge: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { mode } = useThemeContext();
  const theme = useMemo(() => createAppTheme(mode), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
      <CookieConsentBanner />
    </ThemeProvider>
  );
};

const AppProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ThemeContextProvider>
    <ThemeBridge>{children}</ThemeBridge>
  </ThemeContextProvider>
);

export default AppProviders;
